import React from "react";
import { Search, Loader, User, ChevronRight } from "lucide-react";

const EmployeeSelectStep = ({
  theme, isRTL, t,
  employees, loading,
  search, onSearchChange,
  onSelectEmployee,
}) => {
  const filtered = employees.filter((emp) => {
    const name = [
      emp.sr, emp.name, emp.employeeName, emp.fullName, 
      emp.arabicName, emp.nameArabic, emp.arabic_name, emp.englishName
    ].filter(Boolean).join(" ").toLowerCase();
    
    const code = String(emp.infinityCode || "").toLowerCase();
    const email = (emp.email || emp.personalEmail || "").toLowerCase();
    const phone = (emp.phone || emp.mobile || emp.mobileNumber || "").toLowerCase();
    const q    = search.toLowerCase();
    
    return !q || name.includes(q) || code.includes(q) || email.includes(q) || phone.includes(q);
  });

  return (
    <div>
      {/* Search Box */}
      <div style={{ position: "relative", marginBottom: "16px" }}>
        <Search
          size={16}
          style={{
            position: "absolute", top: "50%",
            [isRTL ? "right" : "left"]: "14px",
            transform: "translateY(-50%)",
            color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af",
            pointerEvents: "none",
          }}
        />
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t.searchEmployeePlaceholder || "Search by name, email, ID or phone..."}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: isRTL ? "12px 40px 12px 14px" : "12px 14px 12px 40px",
            background: theme === "dark" ? "rgba(255,255,255,0.07)" : "#f9fafb",
            border: theme === "dark"
              ? "1.5px solid rgba(255,255,255,0.15)"
              : "1.5px solid rgba(0,0,0,0.12)",
            borderRadius: "12px",
            color: theme === "dark" ? "#fff" : "#1a1a1a",
            fontSize: "14px",
            outline: "none",
          }}
        />
      </div>

      {/* Employee List */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "48px 0", color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af" }}>
          <Loader size={32} className="spin" style={{ margin: "0 auto 12px" }} />
          <div>{t.loading}</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "400px", overflowY: "auto" }}>
          {filtered.map((emp) => (
            <button
              key={emp.infinityCode || emp.id}
              onClick={() => onSelectEmployee(emp)}
              style={{
                display: "flex", alignItems: "center", gap: "14px",
                padding: "14px 16px", borderRadius: "12px", border: "none",
                background: theme === "dark" ? "rgba(255,255,255,0.05)" : "#f9fafb",
                cursor: "pointer",
                textAlign: isRTL ? "right" : "left",
                transition: "background 0.2s",
                width: "100%",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = theme === "dark" ? "rgba(46,124,186,0.25)" : "#e8f2fb"}
              onMouseLeave={(e) => e.currentTarget.style.background = theme === "dark" ? "rgba(255,255,255,0.05)" : "#f9fafb"}
            >
              {/* Avatar */}
              <div style={{
                width: 40, height: 40, borderRadius: "50%",
                background: "linear-gradient(135deg,#2e7cba,#2e7cba)",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontWeight: "700", fontSize: "16px", flexShrink: 0,
              }}>
                {(emp.sr || emp.name || emp.employeeName || emp.fullName || "?").charAt(0).toUpperCase()}
              </div>

              {/* Name / Code / Email */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: "600", fontSize: "15px", color: theme === "dark" ? "#fff" : "#1a1a1a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {emp.sr || emp.name || emp.employeeName || emp.fullName}
                </div>
                <div style={{ fontSize: "12px", color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af", display: "flex", gap: "8px", alignItems: "center" }}>
                  <span>#{emp.infinityCode}</span>
                  {(emp.email || emp.personalEmail) && (
                    <span style={{ opacity: 0.7 }}>•</span>
                  )}
                  {(emp.email || emp.personalEmail) && (
                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px" }}>
                      {emp.email || emp.personalEmail}
                    </span>
                  )}
                </div>
              </div>

              <ChevronRight size={16} color={theme === "dark" ? "rgba(255,255,255,0.4)" : "#9ca3af"} style={{ transform: isRTL ? "rotate(180deg)" : "none" }} />
            </button>
          ))}

          {filtered.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px 0", color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af" }}>
              <User size={40} style={{ margin: "0 auto 12px", opacity: 0.3 }} />
              <div>{t.noEmployeesFound}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmployeeSelectStep;